interface IProps {
  title: string;
  text: string;
  backgroundColor: string;
}

export const TextCard = ({ title, text, backgroundColor }: IProps) => {
  return (
    <div
      className={`flex flex-col relative h-full min-h-36 p-6 rounded-md ${backgroundColor}`}
    >
      <h3 className={"w-[80%] lg:text-2xl font-extrabold text-primary-500"}>
        {title}
      </h3>
      <p className={"pt-2 lg:text-lg text-primary-400"}>{text}</p>
    </div>
  );
};
